/// <summary>
/// This object provides js functions for project infos <br/>
/// On the left side it implements a free text div and an optional text editor for admins<br/>
/// On the right side it implements a list of external links/urls - admins can additionally add internal links
/// <br/>
/// Author: AFU<br />
/// Date: 17.10.2024<br />
/// Copyright ©: EUDT GmbH 2024 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 22.10.2024                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.ProjectInfo", jQuery.common.vcBaseV4, {
    editListIndex: -1, //helper for finding the right index of the link list we want to edit

    _create: function () {
        this._createVisual(365);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".project-info");
            me.myRoot.parent().css('min-width', 0);

            me.specific.isAdmin = JSON.parse(me.specific.isAdmin);

            me._buildHtml();
            me._setHeightsAndWidths();
        } catch (e) { me._writeErr(e); return false;}
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            me.myData = { editor: "", list: null };
            me._initStructure();
            me._fetch();
        } catch (e) { me._writeErr(e);return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {

         
           
            //init the main html parts
            me.myHtml = { left: {}, right: {}, text: {}, editor: {}, list: {}, editForm: {}};

            //add the left column
            let obj = me.myHtml.left;
            obj.wrapper = me._setWrapper("", "left vc-list vc-grid-margin-right  float-box");

            // if admin add the edit button in the header
            if (me.specific.isAdmin) {
                obj.edit = me._setWrapper("", "btn-edit vc-grid-1col").html(me.specific.resources.edit).button();
                obj.wrapper.append(obj.edit);
            }

            //add a header for the left column
            obj.header = me._setListHeader(me.specific.isAdmin ? "header-left" : "");
            var line = me._setListItem();
            line.column.append(me._setListElement("", "").html(me.specific.resources.docu));
            obj.wrapper.append(obj.header.append(line.item));

            //add text div
            obj = me.myHtml.text;
            obj.wrapper = me._setWrapper("", "text").html("");
            me.myHtml.left.wrapper.append(me.myHtml.text.wrapper);

            //if admin - add the text editor
            if (me.specific.isAdmin) {
                obj = me.myHtml.editor;
                obj.wrapper = me._setWrapper("", "editor vc-grid-margin-top");
                obj.save = me._setWrapper("", "btn-save-editor vc-grid-1col").html(me.specific.resources.save).button();
                obj.hr = $("<div>").css("clear", "both");
                obj.editor = $("<textarea>").attr("id", "txt-editor").hide();
                obj.wrapper.append(obj.save, obj.hr, obj.editor);
                me.myHtml.left.wrapper.append(me.myHtml.editor.wrapper);
            }

            //right col - links list
            obj = me.myHtml.right;
            obj.wrapper = me._setWrapper("", "right vc-grid-3col float-box");

            obj = me.myHtml.list;
            obj.wrapper = me._setWrapper("", "vc-list");
            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "").html(me.specific.resources.links));
            obj.header.append(line.item);
            obj.add = me._setWrapper("", "").css("text-align", "center");
            obj.btnAdd = me._setWrapper("", "btn-list-add vc-grid-1col vc-grid-margin-top").html(me.specific.resources.newEntry).button()
            obj.add.append(obj.btnAdd);

            //add entries list
            obj.entries = me._setObj("entries", "vc-list-table").css("overflow", "auto");
            obj.wrapper.append(obj.header, obj.add, obj.entries);

            me.myHtml.right.wrapper.append(me.myHtml.list.wrapper);

            //put everything together
            me.myRoot.append(me.myHtml.left.wrapper, me.myHtml.right.wrapper);

            //init the popup for the edit form (and hardcode the width and height)
            me._initEditDialog(1, 1, "project-info");
            me.editDialog.dialog("option", { width: 482, height: 460 });
            me.editDialog.width = 482;
            me.editDialog.height = 430;
            me._buildEditForm();

        } catch (e) {me._writeErr(e);return false;}
        return true;
    },

    _buildEditForm: function () {
        /// <summary>
        /// We init everything we need for the popup form
        /// </summary>
        var me = this;
        var w, h;
        try {

            if (me.error) { return false; }

            //we get some height and width
            w = me.editDialog.width - 27;
            h = me.editDialog.height - 100;

            //set the comlete form
            me.myHtml.editForm.wrapper = $("<div>").attr("id", "div-list-entry").addClass("yform full");
            h -= 5;   //subtract the header
            var div = me.myHtml.editForm.wrapper;

            div.width(w).height(h);
            
            //hardcoded dropdown
            var ddlScope = $("<select>").attr("id", "ddl-scope").addClass("ddl").css("width", "100%");
            ddlScope.append($("<option>").attr("value", 0).text(me.specific.resources.internal));
            ddlScope.append($("<option>").attr("value", 1).text(me.specific.resources.public));
            ddlScope.val(me.specific.isAdmin ? 0 : 1);
           
            //fieldset and formitem for scope dropdown
            let fldScope = ($("<fieldset>").addClass("fieldset vc-grid-3col")).append($("<legend>").html(me.specific.resources.scope));
            let fldScopeDiv = ($("<div>").addClass("formItem type-select")).append(ddlScope);

            me.myHtml.editForm.ddlScope = ddlScope;
            //if not admin - hide the scope - users only see public links
            if (me.specific.isAdmin == false) { fldScope.hide() };

            //fieldset and formitem for link name
            let txtName = $("<input>").attr("id", "txt-name").addClass("formItem txtEnabled").css("width", "98%").val("");
            let fldName = ($("<fieldset>").addClass("fieldset vc-grid-3col")).append($("<legend>").html(me.specific.resources.name));
            let fldNameDiv = $("<div>").addClass("formItem type-text").append(txtName);
            me.myHtml.editForm.txtName = txtName;
           
            //fieldset and formitem for link url
            let txtUrl = $("<textarea>").attr("id", "txt-url").addClass("formItem txtEnabled").css("width", "98%").height(80).val("");
            let fldUrl = ($("<fieldset>").addClass("fieldset vc-grid-3col")).append($("<legend>").html(me.specific.resources.url));
            let fldUrlDiv = $("<div>").addClass("formItem type-text").append(txtUrl);
            me.myHtml.editForm.txtUrl = txtUrl;
           
            //add save and delete button
            me.myHtml.editForm.btnSave = me._setWrapper("", "btn-edit-save vc-grid-1col vc-grid-margin-top").html(me.specific.resources.save).button();
            me.myHtml.editForm.btnDel = me._setWrapper("", "btn-edit-del vc-grid-1col vc-grid-margin-top").css("float", "right").html(me.specific.resources.delete).button();

            div.append(fldScope.append(fldScopeDiv), fldName.append(fldNameDiv), fldUrl.append(fldUrlDiv), me.myHtml.editForm.btnSave, me.myHtml.editForm.btnDel);

            me.editDialog.html(div);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            me._setLoadingIcon(me.myHtml.text.wrapper);
            me._setLoadingIcon(me.myHtml.list.entries);

            //add button for new link
            me.myHtml.list.btnAdd.off("click").on("click", function () { me._addLink(); });

            //add click handler for edit link in list
            me.myHtml.list.wrapper.off("click", ".btn-list-edit").on("click", ".btn-list-edit", function (e) { me._editLink($(e.target)); e.stopPropagation(); });

            //validate input fields on every keyup
            me.myHtml.editForm.wrapper.find(".txtEnabled").keyup(function () { me._validate($(this)); });
            //add save and delete button handler
            me.myHtml.editForm.btnSave.off("click").on("click", function () { me._updateLink(); });
            me.myHtml.editForm.btnDel.off("click").on("click", function () {
                me.openAskDialog(me.specific.resources.delEntry, { at: 'center center-30%', of: window }, function () {
                    me._delLink();
                    return true;
                }, function () {
                   return true;
                }); 



                //
            });

            //if admin - init the text editor, the toggle and save button
            if (me.specific.isAdmin) {
                //admin only
                me.myHtml.editor.cl = null;
                me.myHtml.editor.save.off("click").on("click", function () { me._save(true); }).button("disable");
                me.myHtml.left.edit.off("click").on("click", function () { me._toggleEdit(); });
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _toggleEdit: function () {
        /// <summary>
        /// This function shows/hides the free text div or the text editor
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            if (me.myHtml.text.wrapper.is(":visible")) {
                me.myHtml.text.wrapper.hide();
                me.myHtml.editor.wrapper.show();
                me.myHtml.left.edit.button('option', 'label', me.resources.cancel);
            } else {
                me.myHtml.text.wrapper.show();
                me.myHtml.editor.wrapper.hide();
                me.myHtml.left.edit.button('option', 'label', me.specific.resources.edit);
            }
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _addLink: function () {
        /// <summary>
        /// This function inits a new link entry
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            me._fillEditForm(-1, me.myData.list);
            //we need no delete button for new entry
            me.myHtml.editForm.btnDel.hide();
            me.editDialog.dialog("open");

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _editLink: function (obj) {
        /// <summary>
        /// This function inits the edit form with the list index of the given entry
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            //we need the delete button for existing entry
            me.myHtml.editForm.btnDel.show();
            me._fillEditForm(parseInt(obj.data("index")), me.myData.list);
            me.editDialog.dialog("open");

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _updateLink: function () {
        /// <summary>
        /// This function updates the link list when saving
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            let frm = me.myHtml.editForm;
            var link = {}
            link.Public = frm.ddlScope.val() == "0" ? false : true;
            link.Name = me.myHtml.editForm.wrapper.find("#txt-name").val();
            link.Url = me.myHtml.editForm.wrapper.find("#txt-url").val();

            if (me.editListIndex == -1) {
                me.myData.list.push(link);
            } else {
                me.myData.list[me.editListIndex] = link;
            }

            me.editDialog.dialog("close");
            //we save without saving the editor
            me._save(false);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _delLink: function () {
        /// <summary>
        /// This function deletes the given link
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            //stop if we have no given index
            if (me.editListIndex == -1) return true;
            //kill the entry
            me.myData.list[me.editListIndex] = null;
             //make a new list without the empty entry
            me.myData.list = jQuery.grep(me.myData.list, function (value) { return value != null;});

            me.editDialog.dialog("close");
            //we save without saving the editor
            me._save(false);
           
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _fillEditForm: function (listIndex, list) {
        /// <summary>
        /// This function fills the edit form with a new or existing entry
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            let frm = me.myHtml.editForm; 
            //set the current list index
            me.editListIndex = listIndex;
            if (listIndex == -1) {
                frm.ddlScope.val(me.specific.isAdmin ? 0 : 1);
                frm.wrapper.find("#txt-name, #txt-url").val("");
            } else {
              
                var link = list[listIndex];
                frm.ddlScope.val(link.Public == false ? 0 : 1);
                frm.wrapper.find("#txt-name").val(link.Name);
                frm.wrapper.find("#txt-url").val(link.Url);
            }

            //set the first entry states
            me._validate(frm.wrapper.find("#txt-name"));
            me._validate(frm.wrapper.find("#txt-url"));

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _validate: function (obj) {
        /// <summary>
        /// This function validates the given input fields in the edit form
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            let x = obj.parents(".formItem").removeClass("formItemInvalid");
            if (validateNotEmpty(obj.val()) === false) {x.addClass("formItemInvalid"); }

            //disable the save button when at least 1 field is invalid
            me.myHtml.editForm.btnSave.button(me.myHtml.editForm.wrapper.find(".formItemInvalid").length == 0 ? "enable" : "disable");

        } catch (ex) { me.writeError('validate', ex); return false; }
        return true;
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current setings
        /// </summary>
        var me = this;
        try {

            me.getData({ TypeId: 1 }, function (result) {

                //check response content
                if (result == null) {me.showMessage(me.resources.err_loadData, true);return true;}

                me.myData.data = result;
                me.myData.list = result.Links;
                //write text to the free text
                me.myHtml.text.wrapper.html(result.Text);
                //generate the links list
                me._generateList();
                //if admin - init the text editor
                if (me.specific.isAdmin) {
                    me.myData.editor = me.myData.data.Text;
                    me.myHtml.editor.editor.val(me.myData.editor);
                    me._initTextEditor();
                }
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initTextEditor: function () {
        /// <summary>
        /// This function inits the text editor
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            me.myHtml.editor.editor.show();
            //init the text editor with the height and with we calculated in _setHeightsAndWidths
            me.myHtml.editor.cl = me.myHtml.editor.editor.cleditor({
                'height': me.myHtml.editor.editorSize.h, 'width': me.myHtml.editor.editorSize.w,
                updateTextArea: function (e) {

                    //special hack for copying html code into the text editor
                    if (e.indexOf("mso-ansi-language") > -1 || e.indexOf("<o:") > -1 || e.indexOf("<w:") > -1) {
                        me.myHtml.editor.editor.val(me.myData.editor).blur();
                        //me.openInfoDialog(me.resources.dontPasteFromOutlookToEditor, { at: 'center center-20%', of: window });
                    
                        me.openHtmlCleanupDialog();
                        return true;

                    } else {
                        //save the current ext
                        me.myData.editor = e;
                    }
                    me.myHtml.editor.save.button("enable");
                },
                controls: 'bold italic underline |  removeformat | bullets numbering '
            })[0];

            me.myHtml.editor.cl.refresh();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _save: function (bSaveEditor) {
        /// <summary>
        /// This function saves the current entry
        /// if bSaveEditor == false then only the list entries have been saved - no need to change something in the editor
        /// It is called by clicking on the save button
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            var infos = me.myData.data;
            infos.Text = me.myData.editor;
            infos.Links = me.myData.list;

            //sort the links by name
            infos.Links.sort(function (a, b) {return a.Name.localeCompare(b.Name); });

            me.updateData({ TypeId: 0, Infos: infos }, function (result) {
                if (result === false) { me.showMessage(me.resources.err_saveData, true); return false; }
                //if we saved the free text - let's go back to the free text div
                if (me.specific.isAdmin && bSaveEditor) {
                    me.myHtml.text.wrapper.html(me.myData.editor);
                    me._toggleEdit();
                } 
                //reload the links list
                me._generateList();
                return true;
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _generateList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            if (me.myData.data.Links.length == 0) {
                me.myHtml.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            //clear list
            me.myHtml.list.entries.html("");

            var index = 0;
            // fill entry list
            $.each(me.myData.data.Links, function (key, row) {



                //show public entries only to normal users
                if (row.Public || me.specific.isAdmin) {
                    me.myHtml.list.entries.append(me._fillRow(index, row));
                }
                index++;
            });
            me._setAltListStyle(me.myHtml.list.entries);
           
        } catch (e) {me._writeErr(e);return false;}
        return true;
    },

    _fillRow: function (index, row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            //get the public or internal icon
            var icon = row.Public ? ($("<i>").attr("title",me.specific.resources.public).data("index", index).addClass("fa fa-eye icon-color-info")) : ($("<i>").data("index", index).addClass("fa fa-ban icon-color-error")).attr("title",me.specific.resources.internal); 
            var text = $("<a>", { "href": (row.Url.indexOf("https") == 0 ? "" : "https://") + row.Url, "target": "_blank", text: row.Name });
            var line = me._setListItem();
            line.item.addClass("found");
            line.column.append(me._setListElement("", "w5").html(icon));
            line.column.append(me._setListElement("", "w90").html(text));
            line.column.append(me._setListElement("", "w5").css("text-align", "right").html($("<i>").data("index", index).addClass("btn-list-edit fa fa-pencil color-font-secondary")));
            return line.item;
        } catch (e) { me._writeErr(e); return null; }
    },

    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            var h = me._getVisualHeight();

            //remove the left header (as good as possible)
            var hLeft = h - me.myHtml.left.header.height()-21;

            //set the left width 
            var wLeft = me.container.width - parseInt(me.myHtml.right.wrapper.outerWidth()) - 21;
           
           //set the width of different parts
            me.myHtml.left.wrapper.height(h).width(wLeft);
            me.myHtml.text.wrapper.height(hLeft);

            //save the width for the editor - we need it when initiating the editor
            if (me.specific.isAdmin) {
                me.myHtml.editor.wrapper.height(hLeft + 6);
                me.myHtml.editor.editorSize = { h: hLeft - me.myHtml.editor.save.height() - 11, w: wLeft - 4 };
            }


            me.myHtml.right.wrapper.height(h-3);
          
            me.myHtml.list.wrapper.css("height", h);
            h -= (me.myHtml.list.header.outerHeight()+me.myHtml.list.btnAdd.outerHeight()+38);
            me.myHtml.list.entries.css("max-height",h);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.left.wrapper.hide();
                me.myHtml.right.wrapper.hide();
            }
           
        } catch (e) { me._writeErr(e); return false;}
        return true;
    }
});